import { useMemo, useState } from 'react';
import { Flex, Image, Typography } from 'antd';
import type { ShipmentListType } from 'schemas/shipment/inbound/list';
import { getListProductImages } from '@utility/utils/shipment-display';

const { Text } = Typography;

type ProductThumbsCellProps = {
  row: ShipmentListType;
};

export function ProductThumbsCell({ row }: ProductThumbsCellProps) {
  const images = useMemo(() => getListProductImages(row.items), [row.items]);
  const totalItems = row.items?.length ?? 0;
  const [failedUrls, setFailedUrls] = useState<Set<string>>(() => new Set());

  const visibleImages = images.filter(url => !failedUrls.has(url));
  const showTotalLabel = totalItems > visibleImages.length;

  if (visibleImages.length === 0) {
    return (
      <Text type="secondary" style={{ fontSize: 14 }}>
        {totalItems} total items
      </Text>
    );
  }

  return (
    <Flex vertical gap={6} align="flex-start">
      <Flex gap={6} align="center" wrap="wrap">
        {visibleImages.map(url => (
          <Image
            key={url}
            src={url}
            alt=""
            width={48}
            height={48}
            style={{ objectFit: 'cover', borderRadius: 4, flexShrink: 0 }}
            preview={false}
            onError={() => setFailedUrls(prev => new Set(prev).add(url))}
          />
        ))}
      </Flex>
      {showTotalLabel ? (
        <Text type="secondary" style={{ fontSize: 12, lineHeight: '16px' }}>
          {totalItems} total items
        </Text>
      ) : null}
    </Flex>
  );
}
